
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <DataTable
        :value="customers"
        :lazy="true"
        :paginator="true"
        class="p-datatable-customers "
        :rows="per_page"
        :totalRecords="totalRows"
        @page="onPage($event)"
        @sort="onSort($event)"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        :loading="loading"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[25,50,100]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
      
       
        <template #empty> No record found. </template>
        <template #loading> Loading data. Please wait. </template>
      
        <Column
          header="Username"
          :sortable="true"
          sortField="username"
          filterField="username"
          filterMatchMode="contains"
        >
          <template #body="slotProps">
            <span class="p-column-title">username</span>

          <small><router-link target="_blank" :to="'/users/list/'+slotProps.data.user.id" > {{ slotProps.data.user.username }}</router-link></small> 
          </template>
          <template #filter>
            <InputText
              type="text"
              v-model="filters.username"
              @keydown.enter="topFilter(filters.username, 'username')"
              class="p-column-filter"
              placeholder="Search username"
            />
          </template>
        </Column>

        <Column header="Email"  :sortable="true"
          sortField="email"
          filterField="email"
          filterMatchMode="contains" >
          <template #body="slotProps">
            {{ slotProps.data.user.email }}
            
          </template>
          <template #filter>
            <InputText
              type="text"
              v-model="filters.email"
              @keydown.enter="topFilter(filters.email, 'email')"
              class="p-column-filter"
              placeholder="Search Email"
            />
          </template>
         
        </Column>

    
    
       
       
        <Column header="TransferType" class="col-12"   :sortable="true"
          sortField="transfer_via"
          filterField="transfer_via"
          filterMatchMode="contains" >
          <template #body="slotProps">
            {{ slotProps.data.transfer_via }}
          </template>

              <template #filter>
            <InputText
              type="text"
              v-model="filters.transfer_via"
              @keydown.enter="topFilter(filters.transfer_via, 'transfer_via')"
              class="p-column-filter"
              placeholder="Search transfer"
            />
          </template>
        </Column>
        <Column header="Currency" class="col-12"   :sortable="true"
          sortField="currency"
          filterField="currency"
          filterMatchMode="contains" >
          <template #body="slotProps">
            {{ slotProps.data.currency }}
          </template>

          <template #filter>
            <InputText
              type="text"
              v-model="filters.currency"
              @keydown.enter="topFilter(filters.currency, 'currency')"
              class="p-column-filter"
              placeholder="Search currency"
            />
          </template>
        </Column>
        <Column header="Blockchain" class="col-12"   :sortable="true"
          sortField="chain_type"
          filterField="chain_type"
          filterMatchMode="contains" >
          <template #body="slotProps">
            {{ slotProps.data.chain_type }}
          </template>
          <template #filter>
            <InputText
              type="text"
              v-model="filters.chain_type"
              @keydown.enter="topFilter(filters.chain_type, 'chain_type')"
              class="p-column-filter"
              placeholder="Search chain_type"
            />
          </template>
         
        </Column>


        <Column
          header="Date"
          :sortable="true"
          sortField="created_at"
          filterField="created_at"
          filterMatchMode="contains"
        >
          <template #body="slotProps">
            <span class="p-column-title">Created At</span>
            <span
              :class="'customer-badge status-' + slotProps.data.created_at"
              >{{
                new Date(slotProps.data.created_at).toLocaleDateString("en-US")
              }}</span
            >
          </template>
          <template #filter>
            <Calendar
              v-model="filters.date"
              :showButtonBar="true"
              dateFormat="yy-mm-dd"
              class="p-column-filter"
              @date-select="topFilter(filters.date, 'date')"
              placeholder="Transaction Date"
            />
          </template>
        </Column>
        <Column
          header="Amount"
          :sortable="true"
          sortField="amount"
          filterField="amount"
          filterMatchMode="contains"
        >
          <template #body="slotProps">
            <span class="p-column-title">Amount</span>

            {{ slotProps.data.amount }}
          </template>
          <template #filter>
            <InputText
              type="text"
              v-model="filters.amount"
              @keydown.enter="topFilter(filters.amount, 'amount')"
              class="p-column-filter"
              placeholder="Search amount"
            />
          </template>

        </Column>
        <Column
          header="Fee"
          :sortable="true"
          sortField="extra"
          filterField="extra"
          filterMatchMode="contains"
        >
          <template #body="slotProps">
            <span class="p-column-title">Fee</span>

            {{ slotProps.data.extra }}
          </template>
          <template #filter>
            <InputText
              type="text"
              v-model="filters.extra"
              @keydown.enter="topFilter(filters.extra, 'extra')"
              class="p-column-filter"
              placeholder="Search Fee"
            />
          </template>

        </Column>
       
        <Column
          field="status"
          header="Status"
          :sortable="true"
          filterMatchMode="equals"
        >
          <template #body="slotProps">
            <span class="p-column-title">Status</span>
            <span :class="'customer-badge status-' + slotProps.data.status">{{
              slotProps.data.status
            }}</span>
          </template>
          <template #filter>
            <!-- <InputText type="text" v-model="filters.status" class="p-column-filter"  @keydown.enter="onFilter($event)" placeholder="Search by status"/> -->
            <Dropdown
              v-model="filters.status"
              @change="topFilter($event.value, 'status')"
              :options="statuses"
              placeholder="Select Status"
              class="p-column-filter"
              :showClear="true"
            >
              <template #option="slotProps">
                <span :class="'customer-badge status-' + slotProps.option">{{
                  slotProps.option
                }}</span>
              </template>
            </Dropdown> </template
          >
        </Column>
        <Column
          header="Action" 
        >
          <template #body="slotProps" >
          <p class="d-flex align-items-center">
            <span class="p-column-title">Action</span>

            <button class="btn btn-primary btn-md btn-label"  v-if="slotProps.data.status=='pending'"  @click="withdrawPost(slotProps.data.id)" type="button"><!---->
            <div class="btn-content"><i class="bx bx-loader label-icon"></i> Withdraw </div></button>
            <button class="btn btn-danger mx-2 btn-md btn-label" v-if="slotProps.data.status=='pending'"  @click="withdrawPostReject(slotProps.data.id)" type="button"><!---->
            <div class="btn-content"><i class="bx bx-hourglass label-icon"></i>Reject </div></button>
           

         
            <button class="btn btn-success btn-md btn-label" v-else type="button"><!---->
            <div class="btn-content"><i class="bx bx-check-double label-icon"></i> Success </div>
            </button>
            </p>
          </template>
         </Column>

       
      
         <Column
         header="to_address"
         :sortable="true"
         sortField="to_address"
         filterField="to_address"
         filterMatchMode="contains"
       >
         <template #body="slotProps">
           <span class="p-column-title">to_address</span>
 
          <small> {{ slotProps.data.to_address }}</small>
         </template>
         <template #filter>
           <InputText
             type="text"
             v-model="filters.to_address"
             @keydown.enter="topFilter(filters.to_address, 'to_address')"
             class="p-column-filter"
             placeholder="Search to_address"
           />
         </template>
 
       </Column>
       

      
      </DataTable>
    </div>
  </Layout>
</template>
    
    <script>
import Layout from "../../../layouts/main";
import ApiClass from "../../../api/api";

import PageHeader from "@/components/page-header";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
// import ColumnGroup from 'primevue/columngroup';
import InputText from "primevue/inputtext";
// import MultiSelect from 'primevue/multiselect';
import Dropdown from "primevue/dropdown";

import Swal from "sweetalert2";
import Calendar from "primevue/calendar";
// import ProgressBar from 'primevue/progressbar';

export default {
  components: {
    Layout,
    PageHeader,
    DataTable,
    Dropdown,
    Calendar,
    Column,
    InputText,
  },
  data() {
    return {
      totalRows: 1,
      per_page: 25,
      page: 1,
      title: "Withdrawal Transactions ",
      items: [
        {
          text: "Transactions",
          href: "/admin",
        },
        {
          text: "Wallet",
          active: true,
        },
      ],
      filters: {
        name: null,
        type: null,
        transfer_via: null,
        amount: null,
        status: null,
        date: null,
        duration: null,
      },
      filter: "",
      customers: [],
      selectedCustomers: null,
      loading: true,
      statuses: ["completed", "pending","rejected"],
      types: ["withdraw", "deposit"],
      transferVias: ["crypto", "bank"],
      duration: ["day", "week", "month"],
    };
  },
  created() {},
  mounted() {
    this.wallet();
  },
  methods: {
    async wallet() {
      await ApiClass.getRequest(
        "admin/users/wallet_transactions/get?per_page=" +
          this.per_page +
          "&page=" +
          this.page +
          "&" +
          this.filter
      ).then(async(res) => {
         
        if (res.data.status_code == 1) {
          this.loading = false;
          this.customers = JSON.parse(JSON.stringify(res.data.data.data));
          this.currentPage = res.data.data.current_page;
          this.totalRows = res.data.data.total;
        }
      });
    },
    async onPage(event) {
    
      if (this.page != event.page + 1) {
        this.loading = !this.loading;
        this.page = event.page + 1;
    this.wallet();
      
      }
    },
    onSort(event) {
      this.loading = !this.loading;
      var sortby = event.sortOrder == 1 ? "asc" : "desc";
      this.filter = "sortby=" + sortby + "&sortbyname=" + event.sortField;
      this.wallet();
    },
    onFilter() {},

    topFilter(columnVal, columnName) {
      console.log(columnVal, columnName);
      if (columnName == "date") {
        columnVal = columnVal.toLocaleDateString("es-US").split("T")[0];
        columnVal = columnVal.replaceAll("/", "-");
        columnVal = columnVal.split("-").reverse().join("-");
      }

      this.loading = !this.loading;
      this.$set(this.filters, columnName, columnVal);
      var x = this.filters;
      const resulted = JSON.parse(JSON.stringify(x), (key, value) =>
        value === null || value === "" ? undefined : value
      );
      let query = new URLSearchParams(resulted).toString();
      this.filter = query;
      this.wallet();
    },
   async withdrawPost(event){
    Swal.fire({
        title: "Are you sure?",
        text: "You won be able to withdraw this!",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, approve it!",
      }).then( async(result) => {
        if (result.value) {

          try {
            await ApiClass.postRequest(
        "admin/users/wallet_transactions/withdraw", true,
        {reqid:event,type:"success"}).then((res) => {
        if (res.data.status_code == 1) {  
         return  Swal.fire("Approve!", res.data.message, "success");
        }
       Swal.fire("Failed!", res.data.message, "error");
        
      });
            
          } catch (err) {
            Swal.fire("Something went wrong!", '', "error");
     

          }
       
        }

      this.wallet();
      }); 
       
     
    },
    
    async withdrawPostReject(event){
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to withdraw this!",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, reject it!",
      }).then( async(result) => {
        if (result.value) {

          try {
            await ApiClass.postRequest(
        "admin/users/wallet_transactions/withdraw", true,
        {reqid:event,type:"rejected"}).then((res) => {
        if (res.data.status_code == 1) {  
          Swal.fire("Rejected!", res.data.message, "success");
        }
       Swal.fire("Failed!", res.data.message, "error");
        
      });
            
          } catch (err) {
            Swal.fire("Something went wrong!", '', "error");
     

          }
       
        }

      this.wallet();
      }); 
    
    },
   
  },
};
</script>
      <style lang="scss">
      .p-datatable .p-datatable-tbody > tr > td {
        padding: 5px;
        font-size: 14px;
    }
    .btn {
      font-size: 10px;
    }
      .p-datatable table {
   
    table-layout: auto !important;
}
.p-paginator {
  .p-paginator-current {
    margin-left: auto;
  }
}
.p-datatable .p-datatable-thead > tr > th{
  padding: 5px;
}

.p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #00acad;
  }
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datepicker {
  min-width: 25rem;

  td {
    font-weight: 400;
  }
}
.p-inputtext {
    margin: 0;
    width: 100%;
}
.p-datatable.p-datatable-customers {
  .p-datatable-header {
    padding: 0.3rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
.p-calendar .p-datepicker {
 z-index: 999;
 width: 350px;
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
.p-datatable .p-datatable-tbody > tr > td{
  padding: 5px;
}
@media screen and (max-width: 64em) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        border: 0 none !important;
        width: 100% !important;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4rem 1rem -0.4rem -0.4rem;
          font-weight: bold;
        }
      }
    }
  }
}
</style>